var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.94,
    height: 19.5,
    viewBox: "0 0 20.94 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72148",
    "data-name": "Group 72148",
    transform: "translate(2.25 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91690",
    "data-name": "Path 91690",
    d: "M20.25,10.89v7.92a1.44,1.44,0,0,1-1.44,1.44H5.13a1.44,1.44,0,0,1-1.44-1.44V10.89m7.92-6.12A2.52,2.52,0,1,0,9.09,7.29h2.52m0-2.52V7.29m0-2.52a2.52,2.52,0,1,1,2.52,2.52H11.61m0,0V20.25M3.33,10.89H20.61a1.08,1.08,0,0,0,1.08-1.08V8.37a1.08,1.08,0,0,0-1.08-1.08H3.33A1.08,1.08,0,0,0,2.25,8.37V9.81A1.08,1.08,0,0,0,3.33,10.89Z",
    transform: "translate(-2.25 -2.25)",
    fill: "none",
    stroke: "#ff220c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.de68c6adee1635fef1e6f520547092b9.svg";
export { ForwardRef as ReactComponent };